import MainNonProfit from "../../components/explore-nonprofit/main-nonprofit";

function ExploreNonProfit() {
  return (
    <div className="">
      <MainNonProfit/>
    </div>
  );
}

export default ExploreNonProfit;


